export const noAddressFoundText = 'No addresses were found';
export const addressOptionSelectionErrorText = 'Error selecting collection address';
export const invalidAddressSelectionErrorText = 'Selected address is not valid, has missing fields';
export const ieDataSet = 'ie-additional-eircode';
export const gbDataSet = 'gb-address';
export const requiredText = '(Required)';
export const optionalText = '(Optional)';
export const errorDuringFetchingText = 'Error fetching address data';
